import { useEffect } from 'react'
import useSearch, { openSearch, setSearchQuery } from '../models/useSearch'

const SEED_CHAR = /^[\w.\-:/@]$/

export default function useSearchHotkey() {
  const searchOpen = useSearch(s => s.open)

  useEffect(() => {
    if (searchOpen) return

    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return

      const target = e.target as HTMLElement | null
      if (target) {
        const tag = target.tagName
        if (tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable) return
      }

      if (document.querySelector('[role="dialog"]')) return

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
        e.preventDefault()
        openSearch()
        return
      }

      if (e.key.length !== 1) return
      if (!SEED_CHAR.test(e.key)) return

      e.preventDefault()
      const current = useSearch.getState().query
      setSearchQuery(current + e.key)
      openSearch()
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [searchOpen])
}
